import React, { useEffect, useState } from 'react';
const notifications = [{
  name: 'Karin L. från Stockholm',
  action: 'köpte just Brainy',
  time: 'för 2 minuter sedan'
}, {
  name: 'Johan B. från Göteborg',
  action: 'köpte just Brainy',
  time: 'för 5 minuter sedan'
}, {
  name: 'Maria S. från Malmö',
  action: 'köpte just Brainy',
  time: 'för 7 minuter sedan'
}, {
  name: 'Anders J. från Uppsala',
  action: 'köpte just Brainy',
  time: 'för 9 minuter sedan'
}, {
  name: 'Eva N. från Linköping',
  action: 'köpte just Brainy',
  time: 'för 12 minuter sedan'
}, {
  name: 'Peter K. från Örebro',
  action: 'köpte just Brainy',
  time: 'för 14 minuter sedan'
}];
export function FakeNotifications() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Show notification every 15-30 seconds
    const showTimer = setInterval(() => {
      setVisible(true);
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      // Hide after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    }, Math.random() * 15000 + 15000);
    // Show first notification after 5 seconds
    const initialTimer = setTimeout(() => {
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    }, 5000);
    return () => {
      clearInterval(showTimer);
      clearTimeout(initialTimer);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 bg-white rounded-lg shadow-lg p-4 max-w-xs z-50 border border-gray-200 animate-slide-in" data-id="element-315">
      <div className="flex items-center" data-id="element-316">
        <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center text-white font-bold mr-3" data-id="element-317">
          ✓
        </div>
        <div data-id="element-318">
          <p className="font-medium" data-id="element-319">{notifications[currentIndex].name}</p>
          <p className="text-sm text-gray-600" data-id="element-320">
            {notifications[currentIndex].action} •{' '}
            {notifications[currentIndex].time}
          </p>
        </div>
      </div>
    </div>;
}